
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

import ServiceSchema from '../components/ServiceSchema';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import FAQSchema from '../components/FAQSchema';

function FiftySeaterbusonrentinpune() {



    const cardData =
    {
        keyword: '50 Seater Bus On Rent in Pune',
        heading: 'Amruta Travels: 50 Seater Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers 50 Seater Bus on Rent in Pune, perfect for transporting large groups with ease and comfort. Whether it is for a wedding celebration, corporate event, school or college trip, or a pilgrimage tour, our 50-seater buses are spacious, well-maintained, and designed for long journeys. Backed by experienced drivers, timely service, affordable pricing, and 24/7 support, we ensure your group travels together safely and comfortably. Choose Amruta Travels for a smooth and reliable 50 Seater Bus rental experience in Pune!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
            },
            {
                "title": "Aga Khan Palace",
                "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
            },
            {
                "title": "Sinhagad Fort",
                "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
            },
            {
                "title": "Osho Ashram",
                "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
            },
            {
                "title": "Fergusson College Road",
                "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
            },
            {
                "title": "Lal Mahal",
                "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
            }
        ],

        "services": [
    {
      "name": "50 Seater Bus Per Km Rate in Pune",
      "description": "Amruta Travels offers competitive per kilometer rates for 50-seater bus rentals in Pune. Our transparent pricing policy ensures there are no hidden charges, making us the ideal choice for long-distance travel, weddings, school trips, and more. Contact us for customized rates based on your route and duration."
    },
    {
      "name": "Bus on Rent in Pimpri Chinchwad",
      "description": "Amruta Travels provides reliable bus rental services in Pimpri Chinchwad for all group sizes. Whether you need a 50-seater for a school outing, corporate trip, or family function, we offer clean, safe, and punctual transportation solutions with flexible booking options."
    },
    {
      "name": "50 Seater Bus on Rent in Hadapsar",
      "description": "Looking for a 50-seater bus in Hadapsar? Amruta Travels offers large-capacity buses for weddings, picnics, or religious tours with timely pickups and door-to-door service. Enjoy peace of mind with our professional drivers and well-maintained fleet."
    },
    {
      "name": "50 Seater Coach Hire Prices",
      "description": "Get affordable 50-seater coach hire prices with Amruta Travels. Our packages are tailored for large groups traveling for events, tourism, or conferences. Choose between per km billing or fixed-day packages based on your travel plan."
    },
    {
      "name": "50 Seater Bus Rent Price",
      "description": "Check the best rates for 50-seater bus rentals in Pune with Amruta Travels. Whether you need AC or non-AC buses, we offer flexible rental pricing options for corporate events, outstation tours, school trips, and more."
    },
    {
      "name": "50 Seater Coach Bus Hire in Pune",
      "description": "Hire a 50-seater coach bus in Pune with Amruta Travels for a comfortable and stress-free travel experience. Our buses feature large seating capacity, ample luggage space, clean interiors, and trained drivers to make every journey safe and enjoyable."
    },
    {
      "name": "50 Seater Bus Hire in Kharadi",
      "description": "Amruta Travels offers 50-seater bus hire services in Kharadi, Pune for weddings, school trips, office outings, and pilgrimage tours. Our localized service ensures timely response, efficient route planning, and seamless transport experience."
    },
    {
      "name": "50 Seater AC Bus Per Km Rate",
      "description": "Amruta Travels provides 50-seater AC buses in Pune at economical per km rates. Perfect for long-distance group travel, our buses are equipped with powerful air conditioning, pushback seats, and experienced drivers for a smooth and cool ride."
    },
    {
      "name": "Hire 50 Seater Bus on Rent",
      "description": "Hire a 50-seater bus from Amruta Travels for any group event in Pune or surrounding areas. Whether it’s a school function, family vacation, or corporate travel, we provide reliable, affordable, and timely bus rental services with personalized support."
    },
    {
      "name": "50 Seater Bus for Hire for Outstation from Pune",
      "description": "Travel to outstation destinations from Pune in a spacious 50-seater bus with Amruta Travels. Ideal for group tours, weddings, and spiritual journeys, our buses come with experienced chauffeurs and safety features to ensure a pleasant trip."
    },
    {
      "name": "50 Seater Bus on Rent for Outstation",
      "description": "Book a 50-seater bus with Amruta Travels for your next outstation journey from Pune. Our buses are suitable for large families, religious groups, and corporate teams who value comfort, cleanliness, and punctuality."
    },
    {
      "name": "50 Seater Bus for Wedding in Pune",
      "description": "Make guest transport hassle-free with a 50-seater wedding bus from Amruta Travels. We manage wedding logistics across Pune and outstation locations, offering AC and non-AC buses to ensure guests travel comfortably and on time."
    },
    {
      "name": "50 Seater Bus on Rent for Corporate Picnic",
      "description": "Organizing a company day out? Book a 50-seater bus from Amruta Travels and ensure a fun, coordinated outing. Our buses feature comfortable seating, music options, and reliable service for a stress-free corporate picnic experience."
    },
    {
      "name": "50 Seater Bus on Rent for Corporate Event",
      "description": "Amruta Travels offers 50-seater buses for corporate events including seminars, expos, and retreats. Enjoy clean, air-conditioned buses operated by professional drivers to ensure a smooth and timely group travel experience."
    },
    {
      "name": "50 Seater Bus on Rent in Viman Nagar",
      "description": "If you're based in Viman Nagar, Amruta Travels provides efficient 50-seater bus rentals for local and long-distance travel. Ideal for schools, weddings, or office events, our fleet ensures clean, reliable, and safe journeys."
    },
    {
      "name": "50 Seater Bus on Rent for Ashtavinayak Darshan",
      "description": "Plan a spiritual journey to the Ashtavinayak temples with Amruta Travels' 50-seater bus service. Enjoy a comfortable pilgrimage experience with expert drivers, planned routes, and devotional ambiance throughout the trip."
    },
    {
      "name": "50 Seater Bus on Rent for Jyotirlinga Darshan",
      "description": "Explore Maharashtra’s sacred Jyotirlingas with Amruta Travels’ 50-seater bus rental. Our package includes flexible scheduling, clean and safe travel conditions, and drivers familiar with the religious circuits to enhance your spiritual journey."
    }
  ],
  "tableData": [
    ["50 Seater Bus Per Km Rate in Pune", "Bus on Rent in Pimpri Chinchwad"],
    ["50 Seater Bus on Rent in Hadapsar", "50 Seater Coach Hire Prices"],
    ["50 Seater Bus Rent Price", "50 Seater Coach Bus Hire in Pune"],
    ["50 Seater Bus Hire in Kharadi", "50 Seater AC Bus Per Km Rate"],
    ["Hire 50 Seater Bus on Rent", "50 Seater Bus for Hire for Outstation from Pune"],
    ["50 Seater Bus on Rent for Outstation", "50 Seater Bus for Wedding in Pune"],
    ["50 Seater Bus on Rent for Corporate Picnic", "50 Seater Bus on Rent for Corporate Event"],
    ["50 Seater Bus on Rent in Viman Nagar", "50 Seater Bus on Rent for Ashtavinayak Darshan"],
    ["50 Seater Bus on Rent for Jyotirlinga Darshan", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Group Travel",
    "WhyChoosedescription": "Amruta Travels offers 50 Seater Bus on Rent in Pune, perfect for large group travel. With spacious seating, ample legroom, and air conditioning, our buses ensure a relaxed and enjoyable ride for all passengers."
  },
  {
    "WhyChooseheading": "Ideal for Events, Tours, and Outings",
    "WhyChoosedescription": "Our 50-seater buses are ideal for weddings, corporate events, school trips, and sightseeing tours. No matter the occasion, we provide reliable and comfortable transportation tailored to your group’s needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Safety and professionalism come first. Our trained drivers are courteous, punctual, and knowledgeable about routes in and around Pune, ensuring a safe and hassle-free journey for your group."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and budget-friendly pricing for 50 Seater Bus on Rent in Pune. With clear, upfront rates and no hidden charges, you can plan your group travel expenses with confidence."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "Our buses are regularly cleaned and serviced to ensure maximum comfort and hygiene. We maintain high standards for vehicle upkeep to give you a smooth and safe travel experience."
  },
  {
    "WhyChooseheading": "24/7 Availability and Flexible Scheduling",
    "WhyChoosedescription": "Whether it’s an early morning departure or a late-night return, our 50 Seater Bus on Rent in Pune is available 24/7 to match your schedule. We offer flexible booking options to meet your specific needs."
  },
  {
    "WhyChooseheading": "Customized Travel Itineraries",
    "WhyChoosedescription": "We offer fully customizable routes and schedules based on your group’s requirements. Whether it’s multiple pick-up points or planned stopovers, we’ll tailor the travel plan to suit your itinerary."
  },
  {
    "WhyChooseheading": "Easy Booking with Excellent Support",
    "WhyChoosedescription": "Booking a 50 Seater Bus with Amruta Travels is quick and hassle-free. Use our online platform, call our customer support, or visit our office—we provide smooth and convenient booking with full assistance."
  }
]
























    }

const faqData = [
  {
    question: 'How can I rent a 50 seater bus in Pune with Amruta Travels?',
    answer: 'Booking a 50 seater bus in Pune with Amruta Travels is simple. You can reserve your bus via our website, call our customer support, or visit our office. We’ll help you with a booking that fits your group travel needs.',
  },
  {
    question: 'What are the features of the 50 seater bus?',
    answer: 'Our 50 seater buses come with push-back seats, powerful air conditioning, large windows for a pleasant view, and spacious luggage compartments. They’re ideal for large group travel, school and college trips, corporate events, and family functions.',
  },
  {
    question: 'Is the 50 seater bus available for outstation trips?',
    answer: 'Yes, the 50 seater bus is available for outstation travel from Pune. We offer safe, smooth, and efficient transport for both short and long-distance trips with experienced drivers.',
  },
  {
    question: 'Can I book the bus for local travel within Pune?',
    answer: 'Yes, the 50 seater bus can be booked for local travel within Pune. Whether it’s a city tour, event transfer, or employee transport, we’ve got you covered.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Absolutely. Our buses undergo routine maintenance and thorough sanitization before each trip to ensure safety, cleanliness, and comfort.',
  },
  {
    question: 'How much does it cost to rent a 50 seater bus in Pune?',
    answer: 'Pricing varies based on your trip distance, duration, and service needs. Contact us with your itinerary for a clear and customized quotation.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations?',
    answer: 'Yes, we offer customized routing with multiple pickup and drop-off points. Just let us know your travel plan in advance and we’ll arrange everything.',
  },
  {
    question: 'Do you provide drivers with the 50 seater bus?',
    answer: 'Yes, all our rentals come with trained and experienced drivers who ensure timely and safe transportation throughout your journey.',
  },
  {
    question: 'Is the 50 seater bus suitable for weddings and events?',
    answer: 'Definitely! Our 50 seater buses are ideal for transporting guests to weddings, social events, and group functions in and around Pune.',
  },
  {
    question: 'Why choose Amruta Travels for 50 seater bus rental in Pune?',
    answer: 'Amruta Travels stands out for providing reliable service, well-maintained buses, skilled drivers, and seamless booking. We prioritize passenger comfort and satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kiran Pawar',
    role: 'Corporate Travel Manager, Pune',
    text: 'We used Amruta Travels for a 50 seater bus rental for our annual company trip. The bus was spacious, neat, and the journey was well-managed. Highly professional!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Swati Joshi',
    role: 'Wedding Coordinator, Pune',
    text: 'The 50 seater bus from Amruta Travels made it easy to transport our guests during the wedding. Everyone was comfortable and impressed with the service.',
    rating: 5,
  },
];




































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
    {
        src: "/images/gallery/24.jpg",
        alt: "50 Seater Bus On Rent in Pune"
    },
    {
        src: "/images/gallery/28.jpg",
        alt: "50 Seater Bus Hire in Pune"
    },
    {
        src: "/images/gallery/2.jpg",
        alt: "50 Seater Bus Rental Pune"
    },
    {
        src: "/images/gallery/3.jpg",
        alt: "50 Seater AC Bus in Pune"
    },
    {
        src: "/images/gallery/24.jpg",
        alt: "Large Group Bus Rental in Pune"
    },
    {
        src: "/images/gallery/27.jpg",
        alt: "50 Seater Bus for Wedding in Pune"
    },
    {
        src: "/images/gallery/29.jpg",
        alt: "50 Seater Bus for Corporate Travel Pune"
    },
    {
        src: "/images/gallery/30.jpg",
        alt: "50 Seater Bus for Outstation Travel from Pune"
    },
    {
        src: "/images/gallery/31.jpg",
        alt: "50 Seater Bus Rental for Group Tours"
    }
];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus On Rent in Pune",
  "image": "https://bushireinpune.com/images/keyword/7.jpg",
  "description": "Hire a 50 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate events, school and college trips, pilgrimage tours, family outings and outstation group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4782"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "38",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/50-seater-bus-on-rent-in-pune"
  }
};








    return (
        <div>


<Helmet>
  <title>
    50 Seater Bus On Rent in Pune | AC & Non-AC Bus Hire | Amruta Travels
  </title>

  <meta
    name="description"
    content="Book a 50 Seater Bus On Rent in Pune for weddings, corporate events, school trips, pilgrimage tours, employee transportation and outstation travel. Comfortable group transportation by Amruta Travels."
  />

  <link
    rel="canonical"
    href="https://bushireinpune.com/50-seater-bus-on-rent-in-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<ServiceSchema
  serviceType="50 Seater Bus On Rent in Pune"
  url="https://bushireinpune.com/50-seater-bus-on-rent-in-pune"
  description="Book a 50 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate travel, school trips, employee transportation, pilgrimage tours and outstation travel."
/>

<BreadcrumbSchema
  pageName="50 Seater Bus On Rent in Pune"
  pageUrl="https://bushireinpune.com/50-seater-bus-on-rent-in-pune"
/>

<FAQSchema faqs={faqData} />

<section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/7.jpg"
    alt="50 Seater Bus On Rent in Pune by Amruta Travels"
/>
                            <h2 className="py-1"
    style={{
        color: '#322E77',
        textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)',
        fontWeight: 'bold'
    }}
>
    {cardData.heading}
</h2>

<p className='fw-bold'>
    {cardData.headingDescription}
</p>

<p>
    If you have a slightly smaller group, you can also explore our{" "}
    <Link to="/40-seater-bus-on-rent-in-pune">
        40 Seater Bus On Rent in Pune
    </Link>{" "}
    for weddings, corporate travel and group tours. For larger groups, our{" "}
    <Link to="/53-seater-bus-on-rent-in-pune">
        53 Seater Bus On Rent in Pune
    </Link>{" "}
    can be considered depending on your passenger requirement.
</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
    <div key={index} className=" my-4">
        <h4 className="py-1 darkcolorrr">{service.name}</h4>
        <p>{service.description}</p>
    </div>
))}

<p>
    For groups that need a slightly smaller vehicle for outstation travel,
    explore our{" "}
    <Link to="/45-seater-bus-on-rent-in-pune">
        45 Seater Bus On Rent in Pune
    </Link>
    ,{" "}
    <Link to="/40-seater-bus-on-rent-in-pune">
        40 Seater Bus On Rent in Pune
    </Link>
    ,{" "}
    <Link to="/35-seater-bus-on-rent-in-pune">
        35 Seater Bus On Rent in Pune
    </Link>
    {" "}or{" "}
    <Link to="/32-seater-bus-on-rent-in-pune">
        32 Seater Bus On Rent in Pune
    </Link>
    {" "}depending on your group size.
</p>
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>

<div className="my-4">
    <h2>People Also Search For</h2>

    <ul>
        <li>
            <Link to="/40-seater-bus-on-rent-in-pune">
                40 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/45-seater-bus-on-rent-in-pune">
                45 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/53-seater-bus-on-rent-in-pune">
                53 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/35-seater-bus-on-rent-in-pune">
                35 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/32-seater-bus-on-rent-in-pune">
                32 Seater Bus On Rent in Pune
            </Link>
        </li>

        <li>
            <Link to="/26-seater-bus-on-rent-in-pune">
                26 Seater Bus On Rent in Pune
            </Link>
        </li>
    </ul>
</div>

<div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default FiftySeaterbusonrentinpune;